import {
  IConditionFieldsFragment,
  IFilterFieldsFragment,
  INamedFilterFieldsFragment,
  IPredicateFieldsFragment,
} from '../../../apollo/graphqlSchema';
import { getCreator } from '../user/utils';
import { IAnalyticsEventFilterFields } from './types';
import { byTypeName } from '../../../types';
import { UnreachableCaseError } from 'ts-essentials';
import {
  getFieldName,
  uniqueAnalyticsLoggedFieldFunction,
} from '../field/utils';
import { MaybeNil } from '../../../interfaces';
import { isNil, uniqBy } from 'lodash';
import { IAnalyticsLoggedField } from '../../types';
import { IOperandValue } from '../../../../components/FilterWidget/types';

export const getFilterEventProperties = (
  filter: INamedFilterFieldsFragment,
): IAnalyticsEventFilterFields => {
  return {
    object_type: 'named filter',
    object_owner: getCreator(filter),
    schema_name: filter.schema.name,
    object_name: filter.name,
    object_id: filter.id,
    fields: getUniqFieldNamesFromFilter(filter),
  };
};

export const getFieldNamesFromPredicate = (
  p: MaybeNil<IPredicateFieldsFragment>,
): IAnalyticsLoggedField[] => {
  if (isNil(p)) {
    return [];
  }
  if (p.__typename === 'SimplePredicate') {
    const fields = [getFieldName(p.field)];

    if (p.operands.__typename === 'FieldOperands') {
      p.operands.fields
        .filter(byTypeName('Field'))
        .forEach((fv) => fields.push(getFieldName(fv)));
    }

    return fields;
  } else if (p.__typename === 'ArrayObjectPredicate') {
    return p.elementPredicates.flatMap(getFieldNamesFromPredicate);
  } else {
    throw new UnreachableCaseError(p);
  }
};

export const getFieldValueKey = (fv: IOperandValue) => {
  switch (fv.__typename) {
    case 'BasicFieldValue': {
      return fv.key;
    }
    case 'AnyFieldValue': {
      return fv.name;
    }
    default:
      throw new UnreachableCaseError(fv);
  }
};

const getFieldNamesFromCondition = (c: IConditionFieldsFragment) => {
  return c.predicates.flatMap(getFieldNamesFromPredicate);
};

export const getFieldNamesFromFilter = (f: MaybeNil<IFilterFieldsFragment>) => {
  return !isNil(f) ? f.conditions.flatMap(getFieldNamesFromCondition) : [];
};

export const getUniqFieldNamesFromFilter = (f: IFilterFieldsFragment) =>
  uniqBy(getFieldNamesFromFilter(f), uniqueAnalyticsLoggedFieldFunction);
